import React, { useEffect } from "react"
import { useInView } from "react-intersection-observer"
import { dispatch } from "../../../../../lib/events"
import { linkStyle } from "./MemberBenefitsLink.css"
import { navigate } from "../../../../../utils/routes"

export const MemberBenefitsLink: React.FC = () => {
  const { inView, ref } = useInView({
    threshold: 1,
    triggerOnce: true,
  })
  const destinationUrl = `/account/member-benefits`

  useEffect(() => {
    if (inView) {
      dispatch("page element viewed", {
        target: "savings_to_date_banner",
        location: "savings_to_date_banner",
      })
    }
  }, [inView])

  return (
    <button
      type="button"
      ref={ref}
      className={linkStyle}
      onClick={() => {
        navigate(destinationUrl)
        dispatch("page element clicked", {
          target: "savings_to_date_banner",
          contentUrl: destinationUrl,
          location: "savings_to_date_banner",
          details: "view_your_member_benefits",
        })
      }}
    >
      View Your NEW Member Perks
    </button>
  )
}
